import { ObjectListEntry } from '../_state/_types';

export type ObjectStatusProps = { status: ObjectListEntry['status'] };

export const withStatusColorStyle = (status: ObjectListEntry['status']) => {
  switch (status) {
    case 'Completed':
      return {
        '--color-custom-color': `var(--color-success)`,
      } as React.CSSProperties;
    case 'Draft':
      return {
        '--color-custom-color': `var(--color-primary)`,
      } as React.CSSProperties;
    case 'Finished':
      return {
        '--color-custom-color': `var(--color-success)`,
      } as React.CSSProperties;
    case 'Open':
      return {
        '--color-custom-color': `var(--color-primary)`,
      } as React.CSSProperties;
    case 'Pending':
      return {
        '--color-custom-color': `var(--color-warning)`,
      } as React.CSSProperties;
    case 'Received':
      return {
        '--color-custom-color': `var(--color-warning)`,
      } as React.CSSProperties;
    case 'Reconciled':
      return {
        '--color-custom-color': `var(--color-success)`,
      } as React.CSSProperties;
    case 'Shipped':
      return {
        '--color-custom-color': `var(--color-primary)`,
      } as React.CSSProperties;
    case 'Unassigned':
      return {
        '--color-custom-color': `var(--color-primary)`,
      } as React.CSSProperties;
    case 'Voided':
      return {
        '--color-custom-color': `var(--color-failure)`,
      } as React.CSSProperties;
  }
};
